import React from 'react';
import './../../../Styles/Main/ProfilePage/ProfilePage.scss'
import { BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import { Scrollbars } from 'rc-scrollbars';
import PagesWrapper from '../../../UI/pagewrapper/PagesWrapper';
import ProfileHeader from './ProfileHeader';
import { useState } from 'react';
import ProfileCurrentTab from './ProfileCurrentTab';
import ProfileHistoryTab from './ProfileHistoryTab';
import ProfileInfoTab from './ProfileInfoTab';

function ProfilePage() {

   const [isCurrentPage, setIsCurrentPage] = useState(true);
   const [isHistoryPage, setIsHistoryPage] = useState(false);
   const [isInfoPage, setIsInfoPage] = useState(false);

   const showPage = (value) => {
      if (value === 'profileHeader-current') {
         setIsCurrentPage(true);
         setIsHistoryPage(false);
         setIsInfoPage(false);
      }
      if (value === 'profileHeader-history') {
         setIsCurrentPage(false);
         setIsHistoryPage(true);
         setIsInfoPage(false);
      }
      if (value === 'profileHeader-info') {
         setIsCurrentPage(false);
         setIsHistoryPage(false);
         setIsInfoPage(true);
      }
   }

   return (
      <div className='profilePage__wrapper'>
         <PagesWrapper>
            <div className="profilePage__body">
               <div className="profilePage__title title-h2">My profile</div>
               <Scrollbars style={{ width: '100%', height: "600px"}}>
                  <div className="profilePage__header">
                     <ProfileHeader showPage={ showPage } />
                  </div>
                  <div className="profilePage__content">
                     <div className={ isCurrentPage ? "profilePage__content-tab" : "profilePage__hide"}>
                        <ProfileCurrentTab
                        />
                     </div>
                     <div className={ isHistoryPage ? "profilePage__content-tab" : "profilePage__hide"}>
                        <ProfileHistoryTab
                        />
                     </div>
                     <div className={ isInfoPage ? "profilePage__content-tab" : "profilePage__hide"}>
                        <ProfileInfoTab/>
                     </div>
                  </div>
               </Scrollbars>
            </div>
         </PagesWrapper>
      </div>
   );
}
export default ProfilePage;